import { Component, Input } from '@angular/core';

@Component({
  selector: 'idp-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent {
  @Input() title = '';
}
